import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import FilterTags from './filter_tags';
import FilterPills from './filter_pills';

import './filters.scss';

const FilterBox = ({
  children,
  className,
  filters,
  filterTags,
  inputRef,
  isMobile,
  onClearFilters,
  rightElement,
  withHorizontalMargin,
  withHorizontalPadding,
  withoutBorder,
  withStyleguide,
}) => (
  <div
    className={classnames('dashboard-filters', className, {
      'dashboard-filters--without-tags': _.isEmpty(filterTags),
      'dashboard-filters--new-header': isMobile === false,
      'dashboard-filters--without-border': withoutBorder,
      'dashboard-filters--with-horizontal-margin': withHorizontalMargin,
      'dashboard-filters--with-horizontal-padding': withHorizontalPadding,
    })}
    ref={inputRef}
  >
    {!_.isEmpty(filterTags) && (
      <div className="dashboard-filters-results">
        {withStyleguide ? (
          <FilterPills filters={filterTags} onClearFilters={onClearFilters} isMobile={isMobile} />
        ) : (
          <FilterTags tags={filterTags} onClearFilters={onClearFilters} />
        )}
      </div>
    )}

    {(!_.isEmpty(filters) || !_.isEmpty(children)) && (
      <div className="dashboard-filters-buttons">
        <div className="dashboard-filters-buttons__container">
          {children}
          {filters}
          {rightElement}
        </div>
      </div>
    )}
  </div>
);

FilterBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.node),
  filterTags: PropTypes.arrayOf(PropTypes.shape({})),
  isMobile: PropTypes.bool,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onClearFilters: PropTypes.func,
  rightElement: PropTypes.node,
  withHorizontalMargin: PropTypes.bool,
  withHorizontalPadding: PropTypes.bool,
  withoutBorder: PropTypes.bool,
  withStyleguide: PropTypes.bool,
};

FilterBox.defaultProps = {
  withStyleguide: false,
};

export default FilterBox;
